// clamp in [min,max]
function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}

document.addEventListener('click', event => {
  const modal = document.querySelector('q-modal[data-modal-active="true"]');
  const closeButton = document.querySelector('#close-modal');
  if (!modal || !closeButton) return;

  const clicked = event.target;
  const img = clicked.closest('.q-figure__image');
  const isButton = clicked.closest('button');
  const isCaptionClick = clicked.closest('.q-lightbox-slides__caption-content');
  const slide = clicked.closest('.q-lightbox-slides__slide');

  if (img && slide) {
    const wasZoomed = img.classList.contains('zoomed');
    const caps = modal.querySelectorAll('.q-lightbox-slides__caption');

    if (!wasZoomed) {
      // calcola frazioni sul thumbnail
      const r = img.getBoundingClientRect();
      const fx = (event.clientX - r.left)  / r.width;
      const fy = (event.clientY - r.top)   / r.height;

      // zoom
      img.classList.add('zoomed');
      // togli ogni max constraint
      img.style.maxWidth  = 'none';
      img.style.maxHeight = 'none';
      // nascondi didascalie
      caps.forEach(c=>c.style.display='none');
      slide.style.overflow = 'auto';

      requestAnimationFrame(()=>{
        const cw = slide.clientWidth,  ch = slide.clientHeight;
        const sw = slide.scrollWidth,  sh = slide.scrollHeight;

        const tx = clamp(fx * sw - cw/2, 0, sw - cw);
        const ty = clamp(fy * sh - ch/2, 0, sh - ch);

        slide.scrollTo({ left: tx, top: ty, behavior: 'smooth' });
      });
    } else {
      // zoom out
      img.classList.remove('zoomed');
      img.style.maxWidth = '';
      img.style.maxHeight= '';
      caps.forEach(c=>c.style.display='');
      slide.scrollTo({ left:0, top:0, behavior:'smooth' });
      slide.style.overflow = '';
    }
    return;
  }

  if (!isButton && !isCaptionClick && modal.contains(clicked)) {
    closeButton.click();
  }
});

// reset on modal-close
const modalEl = document.querySelector('q-modal');
if (modalEl) {
  new MutationObserver(ms => {
    ms.forEach(m => {
      if (m.type==='attributes' && m.attributeName==='data-modal-active'
          && modalEl.getAttribute('data-modal-active')!=='true') {
        document.querySelectorAll('.q-figure__image.zoomed').forEach(img=>{
          img.classList.remove('zoomed');
          img.style.maxWidth = '';
          img.style.maxHeight= '';
        });
        document.querySelectorAll('.q-lightbox-slides__slide').forEach(s=>{
          s.scrollTo({ left:0, top:0 });
          s.style.overflow = '';
        });
        document.querySelectorAll('.q-lightbox-slides__caption').forEach(c=>{
          c.style.display = '';
        });
      }
    });
  }).observe(modalEl, { attributes: true });
}

/* Added 2026-10-14 */

/* Page background from the dominant colour of the photos (Quire)
   1. Each loaded photo is shrunk to a thumbnail; every coloured pixel votes
      for a hue in a histogram (greys, blacks, whites don't vote).
   2. Photos with almost no coloured pixels (B&W) are ignored.
   3. Histograms of all photos are summed; the highest peak is the dominant hue.
   4. If that hue is beige, look for the best peak outside the beige zone and
      use it if it is strong enough.
   5. The hue becomes a light, soft colour (readable with dark text) applied
      to the page containers with a CSS transition.
   6. Lazy loading is untouched: only loaded photos are analysed, and the
      colour is refined as more photos load. */

(() => {
  const SELECTOR = '.q-figure__image';   // photos
  const TRANSITION_MS = 600;             // fade duration

  const LIVE_UPDATE = true;              // recompute as lazy images load
  const UPDATE_DEBOUNCE_MS = 800;        // group bursts of loads into one update

  // Elements receiving the background colour
  const TARGETS = [
    'html',
    'body',
    'main',
    '.quire',
    '.quire-page',
    '#container',
    '.quire-splash .quire-page__content .container .content'
  ].join(', ');

  // Dominant colour detection
  const HUE_BINS = 36;            // 36 bins of 10°
  const MIN_PIXEL_SAT = 0.18;     // below this a pixel is "grey"
  const MIN_PIXEL_LUM = 0.15;     // ignore near-black
  const MAX_PIXEL_LUM = 0.90;     // ignore near-white
  const MIN_COLOUR_RATIO = 0.08;  // below 8% coloured pixels = B&W photo

  // Secondary colour, used when the dominant one is beige
  const BEIGE_CENTER = 30;        // beige zone = 30° ± 25°
  const BEIGE_HALF_WIDTH = 25;
  const ALT_RATIO = 0.25;         // non-beige peak must weigh >= 25% of the dominant

  // Final colour
  const SAT_BOOST = 0.6;          // fraction of detected saturation kept
  const MIN_SATURATION = 0.05;    // clamp: never grey, never too intense
  const MAX_SATURATION = 0.10;
  const MIN_LUMINANCE = 0.82;     // light enough for dark text (midpoint is used)
  const MAX_LUMINANCE = 0.92;

  // Optional: spread similar beige hues apart (1 = off, try 2-3).
  // Hues far from REFERENCE_HUE (e.g. blue) stay almost unchanged.
  const REFERENCE_HUE = 33;
  const HUE_STRETCH = 1;
  const STRETCH_RANGE = 25;

  const cache = new WeakMap();    // img -> analysis, so each photo is analysed once
  const watched = new WeakSet();  // images with a 'load' listener
  let styleEl = null;
  let timer = null;

  // RGB (0-255) -> [hue 0-360, saturation 0-1, lightness 0-1]
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const d = max - min;
    let h = 0, s = 0;
    const l = (max + min) / 2;
    if (d !== 0) {
      s = d / (1 - Math.abs(2 * l - 1));
      switch (max) {
        case r: h = ((g - b) / d) % 6; break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60;
      if (h < 0) h += 360;
    }
    return [h, s, l];
  }

  // HSL -> RGB (0-255)
  function hslToRgb(h, s, l) {
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = l - c / 2;
    let r = 0, g = 0, b = 0;
    if (h < 60)       [r, g, b] = [c, x, 0];
    else if (h < 120) [r, g, b] = [x, c, 0];
    else if (h < 180) [r, g, b] = [0, c, x];
    else if (h < 240) [r, g, b] = [0, x, c];
    else if (h < 300) [r, g, b] = [x, 0, c];
    else              [r, g, b] = [c, 0, x];
    return [r, g, b].map(v => Math.round((v + m) * 255));
  }

  // Signed hue difference, -180..180
  function hueDelta(hue, ref) {
    return ((hue - ref + 540) % 360) - 180;
  }

  function inBeigeZone(hue) {
    return Math.abs(hueDelta(hue, BEIGE_CENTER)) <= BEIGE_HALF_WIDTH;
  }

  // Magnify differences near REFERENCE_HUE, compress the rest so far hues stay put
  function stretchHue(hue) {
    const delta = hueDelta(hue, REFERENCE_HUE);
    const a = Math.abs(delta);
    const inner = STRETCH_RANGE * HUE_STRETCH;
    const out = a <= STRETCH_RANGE
      ? a * HUE_STRETCH
      : inner + (a - STRETCH_RANGE) * (180 - inner) / (180 - STRETCH_RANGE);
    return (REFERENCE_HUE + Math.sign(delta) * out + 360) % 360;
  }

  // Build a hue histogram for one photo (weights, plus sin/cos/saturation
  // sums so the average hue and saturation can be recovered per bin)
  function analyseImage(img) {
    if (!img.complete || !img.naturalWidth || !img.naturalHeight) return null;
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      const scale = Math.min(1, 48 / img.naturalWidth, 48 / img.naturalHeight);
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const px = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

      const bins = {
        w: new Array(HUE_BINS).fill(0),
        sin: new Array(HUE_BINS).fill(0),
        cos: new Array(HUE_BINS).fill(0),
        sat: new Array(HUE_BINS).fill(0)
      };
      let total = 0, colourful = 0;

      for (let i = 0; i < px.length; i += 4) {
        if (px[i + 3] < 128) continue;
        total++;
        const [h, s, l] = rgbToHsl(px[i], px[i + 1], px[i + 2]);
        if (s < MIN_PIXEL_SAT || l < MIN_PIXEL_LUM || l > MAX_PIXEL_LUM) continue;

        // Vote weight: more saturated and mid-lightness = more representative
        const w = s * (1 - Math.abs(2 * l - 1));
        const bin = Math.floor(h / (360 / HUE_BINS)) % HUE_BINS;
        const rad = h * Math.PI / 180;

        bins.w[bin] += w;
        bins.sin[bin] += Math.sin(rad) * w;
        bins.cos[bin] += Math.cos(rad) * w;
        bins.sat[bin] += s * w;
        colourful++;
      }

      if (!total) return null;
      return { bins, total, ratio: colourful / total };
    } catch (e) {
      // Canvas can be blocked (e.g. cross-origin images)
      console.warn('Could not sample image:', e);
      return null;
    }
  }

  // Analyse loaded photos (cached); skip those not downloaded yet
  function getAnalyses(images) {
    const out = [];
    images.forEach(img => {
      if (!img.complete || !img.naturalWidth) return;
      if (!cache.has(img)) cache.set(img, analyseImage(img));
      const a = cache.get(img);
      if (a) out.push(a);
    });
    return out;
  }

  // Highest peak of the summed histogram (smoothed over neighbouring bins),
  // restricted to bins where allowed(i) is true. Returns {hue, sat, score}.
  function findPeak(sum, allowed) {
    const at = i => (i + HUE_BINS) % HUE_BINS;
    const w = i => (allowed(at(i)) ? sum.w[at(i)] : 0);

    let peak = -1, best = 0;
    for (let i = 0; i < HUE_BINS; i++) {
      if (!allowed(i)) continue;
      const score = w(i - 1) + 2 * w(i) + w(i + 1);
      if (score > best) { best = score; peak = i; }
    }
    if (peak < 0) return null;

    // Average hue (via sin/cos, so 359° and 1° average correctly) and
    // saturation around the peak
    let sinS = 0, cosS = 0, wS = 0, satS = 0;
    for (let k = -1; k <= 1; k++) {
      const j = at(peak + k);
      if (!allowed(j)) continue;
      sinS += sum.sin[j];
      cosS += sum.cos[j];
      wS += sum.w[j];
      satS += sum.sat[j];
    }
    if (!wS) return null;

    let hue = Math.atan2(sinS, cosS) * 180 / Math.PI;
    if (hue < 0) hue += 360;
    return { hue, sat: satS / wS, score: best };
  }

  // Returns the final [r, g, b] or null if no colour photo is available
  function calculateBackground(images) {
    const analyses = getAnalyses(images);

    // Drop B&W photos
    const colourImages = analyses.filter(a => a.ratio >= MIN_COLOUR_RATIO);
    console.log(`Photos loaded: ${analyses.length}/${images.length}, colour: ${colourImages.length}`);
    if (!colourImages.length) return null;

    // Sum the histograms; each photo is normalised by its pixel count so
    // that every photo weighs the same
    const sum = {
      w: new Array(HUE_BINS).fill(0),
      sin: new Array(HUE_BINS).fill(0),
      cos: new Array(HUE_BINS).fill(0),
      sat: new Array(HUE_BINS).fill(0)
    };
    colourImages.forEach(a => {
      for (let i = 0; i < HUE_BINS; i++) {
        sum.w[i] += a.bins.w[i] / a.total;
        sum.sin[i] += a.bins.sin[i] / a.total;
        sum.cos[i] += a.bins.cos[i] / a.total;
        sum.sat[i] += a.bins.sat[i] / a.total;
      }
    });

    // Dominant colour overall
    const dominant = findPeak(sum, () => true);
    if (!dominant) return null;

    let chosen = dominant;
    let note = 'dominant';

    // If the dominant colour is beige, try the best non-beige colour
    if (inBeigeZone(dominant.hue)) {
      const binWidth = 360 / HUE_BINS;
      const alt = findPeak(sum, i => !inBeigeZone((i + 0.5) * binWidth));
      if (alt) {
        const ratio = alt.score / dominant.score;
        console.log('Alternative hue:', Math.round(alt.hue),
          'relative weight', ratio.toFixed(2), '(threshold', ALT_RATIO + ')');
        if (ratio >= ALT_RATIO) {
          chosen = alt;
          note = 'alternative';
        }
      }
    }

    const finalHue = stretchHue(chosen.hue);
    console.log(`Chosen (${note}) hue:`, Math.round(chosen.hue),
      '-> used:', Math.round(finalHue), 'saturation:', chosen.sat.toFixed(2));

    // Light, soft version of the colour so dark text stays readable
    const s = Math.max(MIN_SATURATION, Math.min(MAX_SATURATION, chosen.sat * SAT_BOOST));
    const l = (MIN_LUMINANCE + MAX_LUMINANCE) / 2;
    return hslToRgb(finalHue, s, l);
  }

  // Register the transition rule BEFORE changing the colour, so the fade
  // always starts from the standard background
  function ensureStyle() {
    if (styleEl) return;
    styleEl = document.createElement('style');
    styleEl.textContent = `${TARGETS} { transition: background-color ${TRANSITION_MS}ms ease; }`;
    document.head.appendChild(styleEl);
  }

  function setColour(rgb) {
    ensureStyle();
    const css = `
      ${TARGETS} {
        transition: background-color ${TRANSITION_MS}ms ease;
        background-color: rgb(${rgb.join(', ')}) !important;
      }`;
    // Wait two frames so the browser registers the transition first
    requestAnimationFrame(() => requestAnimationFrame(() => {
      styleEl.textContent = css;
    }));
  }

  function update(images) {
    const rgb = calculateBackground(images);
    if (rgb) setColour(rgb);
  }

  // Debounced update, triggered by lazy-loaded images
  function scheduleUpdate(images) {
    clearTimeout(timer);
    timer = setTimeout(() => update(images), UPDATE_DEBOUNCE_MS);
  }

  function init() {
    const images = [...document.querySelectorAll(SELECTOR)];
    if (!images.length) {
      console.info('No images found with', SELECTOR);
      return;
    }

    // First pass on the photos already loaded (lazy loading untouched)
    update(images);

    // Refine as the remaining photos load
    if (LIVE_UPDATE) {
      images.forEach(img => {
        if (img.complete && img.naturalWidth) return;
        if (watched.has(img)) return;
        watched.add(img);
        img.addEventListener('load', () => scheduleUpdate(images), { once: true });
      });
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();









































